export const FILE_TYPES = 'image/jpeg, image/png, image/jpg, image/webp, image/svg+xml';
